import DateTimeSelect from "./DateTimeSelect";

export default function DateSelect(props: FormInput.DateSelect) {
  return <DateTimeSelect {...props} hideTime={true} />;
}
